module.exports = __webpack_public_path__ + "img/phr-banner-4.92dfc9d7.png";